import * as Yup from "yup";

export interface IEmailTemplateFormValues {
  subject: string;
  header: string;
  body: string;
  textColor: string;
  backgroundColor: string;
  buttonColor: string;
  logo?: File | string;
}

export const emailTemplateValidationSchema = Yup.object().shape({
  subject: Yup.string()
    .required("Subject is required")
    .max(200, "Subject must be less than 200 characters"),
  header: Yup.string()
    .required("Header is required"),
  body: Yup.string()
    .required("Body is required"),
  textColor: Yup.string()
    .required("Text color is required"),
  backgroundColor: Yup.string()
    .required("Background color is required"),
  buttonColor: Yup.string()
    .required("Button color is required"),
  logo: Yup.mixed<File | string>().optional(),
});

export const getEmailTemplateInitialValues = (): IEmailTemplateFormValues => ({
  subject: "You're invited to join HighGround via Portland",
  header: "Welcome to HighGround — your security workspace awaits",
  body: "<p>Hi there,</p><p><strong>Portland </strong>has invited you to join their HighGround workspace — a unified hub to monitor your security stack, manage integrations, and track your clients’ services.</p><p><br></p><p>This workspace keeps everything connected, visible, and actionable — helping you stay in control of your performance and client protection.</p><p><br></p><p>Let’s get you started!</p>",
  textColor: "#ffffff",
  backgroundColor: "#000000",
  buttonColor: "#008FD4",
  logo: undefined,
});

